import React from 'react';

import AddAccountFormContainer from '../../AddAccountFormContainer';
import { AddAccountFormViewModel } from 'src/types/view-models/addAccount/addAccount.view.model';
import { InvestmentHoldingType } from 'src/types/investment-holding.model';

export default function BondsForm({ manualAccount, onSubmit, handleBack }: AddAccountFormViewModel): JSX.Element {
    return (
        <AddAccountFormContainer
            manualAccount={manualAccount}
            onSubmit={(values) => {
                void onSubmit(values, manualAccount, false, InvestmentHoldingType.Bonds);
            }}
            handleBack={handleBack}
        />
    );
}
